
define('modules/hypr-fixes/capfirst',[], function() {return function(a){try{return window.scc.global.nu(a)?a.charAt(0).toUpperCase()+a.slice(1):""}catch(b){console.log(b)}}}); 